import {grey600, black} from "material-ui/styles/colors";

const styles = {
    dropzone: {
        display: 'inline-block',
    },
    list: {
        display: 'inline-block',
        position: 'relative',
        top: 0,
        color: black
    },
    listIcon: {
        borderRadius: '10%',
        boxShadow: 'rgba(0, 0, 0, 0.10) 0px 1px 6px, rgba(0, 0, 0, 0.22) 0px 1px 4px'
    },
    avatar: {
        position: 'relative',
        top: -20,
        borderRadius: '10%',
        boxShadow: 'rgba(0, 0, 0, 0.22) 0px 1px 6px, rgba(0, 0, 0, 0.22) 0px 1px 4px'
    },
    box: {
        marginTop: 40,
        paddingRight: 20,
        paddingBottom: 20,
        paddingLeft: 20
    },
    header: {
        float: 'right',
        display: 'inline-block',
        position: 'relative',
        top: 0,
        textAlign: 'right',
        color: black
    },
    headerspan: {
        float: 'right',
        display: 'inline-block',
        position: 'relative',
        top: -20,
        textAlign: 'right',
        fontSize: 13,
        width: '100%',
        color: grey600,
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ApplicationInfo/ApplicationInfo.css.js